import { EMPLOYMENT_TYPE_LABELS, WORK_MODE_LABELS } from '@yeshuman/sdk'
import type { FilterOption } from '@yeshuman/sdk'

/** Closed-set work mode options for unified filter pickers (no pseudo `all` row). */
export const UNIFIED_WORK_MODE_FILTER_OPTIONS: FilterOption[] = Object.entries(WORK_MODE_LABELS).map(
  ([value, label]) => ({ value, label }),
)

/** Closed-set employment options for unified filter pickers (no pseudo `all` row). */
export const UNIFIED_EMPLOYMENT_FILTER_OPTIONS: FilterOption[] = Object.entries(
  EMPLOYMENT_TYPE_LABELS,
).map(([value, label]) => ({ value, label }))
